import TERMS_MARKDOWN from './terms.md?raw';
import { renderMarkdown } from './pageUtils';

// The Terms of Use and Privacy Notice every user accepts at sign-in. Changing the text means raising the version, so
// everyone is asked again; keep it in step with the master copy (the "Terms of Use and Privacy Notice" doc).
export const TERMS_VERSION = '1';
export { TERMS_MARKDOWN };

/** The Terms as HTML. Each table cell carries its column heading (data-label) so a phone can show rows as cards. */
export function termsHtml(): string {
  const doc = new DOMParser().parseFromString(renderMarkdown(TERMS_MARKDOWN), 'text/html');
  for (const table of Array.from(doc.querySelectorAll('table'))) {
    const headings = Array.from(table.querySelectorAll('thead th')).map(th => th.textContent?.trim() ?? '');
    for (const row of Array.from(table.querySelectorAll('tbody tr'))) {
      Array.from(row.children).forEach((cell, i) => { if (headings[i]) cell.setAttribute('data-label', headings[i]); });
    }
  }
  return doc.body.innerHTML;
}
